// app/(home)/components/ImageHotspot.jsx
"use client"


import { useState, useRef, useEffect } from 'react';
const ImageHotspot = ({ src, hotspots }) => {
    const containerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (!containerRef.current) return;

        let isMounted = true;
        let resizeObserver = null;

        const updateSize = () => {
            if (isMounted && containerRef.current) {
                const { width, height } = containerRef.current.getBoundingClientRect();
                setDimensions({ width, height });
            }
        };

        // 创建观察器实例
        resizeObserver = new ResizeObserver(updateSize);
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        // 初始获取尺寸
        updateSize();

        // 清理函数
        return () => {
            isMounted = false;
            if (resizeObserver && containerRef.current) {
                resizeObserver.unobserve(containerRef.current);
                resizeObserver.disconnect();
            }
        };
    }, []);


    // 处理热区点击
    const handleHotspotClick = (action) => {
        // 这里添加具体的点击处理逻辑

        if (action == 'openAppStore') {
            window.open('https://apps.apple.com/cn/app/id1493358574');
        } else if (action == 'openGooglePlay') {
            window.open('https://play.google.com/store/apps/details?id=com.microants.international');
        }
    };

    return (
        <div
            ref={containerRef}
            className="down_tips_img_bx"
        >
            {/* 使用普通img标签获取动态尺寸 */}
            <img
                src={src}
                alt="热点图"
                className="down_tips_img"
                onLoad={(e) => {
                    if (containerRef.current) {
                        const { width, height } = containerRef.current.getBoundingClientRect();
                        setDimensions({ width, height });
                    }
                }}
            />

            {/* 渲染所有热区 */}
            {dimensions.width > 0 && hotspots.map((hotspot) => {
                const scaleX = dimensions.width / hotspot.baseWidth;
                const scaleY = dimensions.height / hotspot.baseHeight;

                return (
                    <div
                        key={hotspot.id}
                        className="down_tips_img_btn"
                        style={{
                            cursor: 'pointer',
                            left: `${hotspot.x * scaleX}px`,
                            top: `${hotspot.y * scaleY}px`,
                            width: `${hotspot.width * scaleX}px`,
                            height: `${hotspot.height * scaleY}px`,
                            // backgroundColor: 'rgba(255,0,0,0.3)' // 调试时可显示热区
                        }}
                        onClick={() => handleHotspotClick(hotspot.action)}
                        aria-label={`热区-${hotspot.id}`}
                    ></div>
                );
            })}
        </div>
    );
};

export default ImageHotspot;